import { render, staticRenderFns } from "./NotFoundView.vue?vue&type=template&id=027f8f3d&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"
import style0 from "./NotFoundView.vue?vue&type=style&index=0&id=027f8f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f8f3d",
  null
  
)

export default component.exports